import { render, staticRenderFns } from "./echarts2.vue?vue&type=template&id=2716820f"
import script from "./echarts2.vue?vue&type=script&lang=js"
export * from "./echarts2.vue?vue&type=script&lang=js"
import style0 from "./echarts2.vue?vue&type=style&index=0&id=2716820f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports